var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-enroll-detail" },
    [
      _c("yxt-page-header", {
        attrs: { title: _vm.$t("pc_biz_enroll_lbl_apply" /* 报名 */) },
        on: { back: _vm.backRouter },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "yxtbiz-enroll-detail__content",
        },
        [
          _vm.record === null
            ? _c(
                "yxt-row",
                {
                  staticClass: "bg-white",
                  attrs: { type: "flex", align: "center", justify: "middle" },
                },
                [!_vm.loading ? _c("yxt-empty") : _vm._e()],
                1
              )
            : [
                _c("div", { staticClass: "yxtbiz-enroll-detail__info" }, [
                  _c(
                    "div",
                    { staticClass: "yxtbiz-enroll-detail__info-user bg-white" },
                    [
                      _c("yxt-avatar", {
                        staticClass: "yxtbiz-enroll-detail__info-user-left",
                        attrs: {
                          size: "70px",
                          imgUrl: _vm.record.user.imgUrl,
                          username: _vm.record.user.fullname,
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "yxtbiz-enroll-detail__info-user-right ml16 text-26",
                        },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top",
                                "open-filter": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: _vm.record.user.fullname },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "font-size-18 font-bolder nowrap ellipsis lh26",
                                },
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: {
                                      name: _vm.record.user.fullname || "--",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt8 font-size-14 text-8c nowrap ellipsis lh20",
                            },
                            [
                              _c("yxtbiz-user-name", {
                                attrs: { name: _vm.record.user.username },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-enroll-detail__info-user-pd d-flex mt8 font-size-14",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_enroll_col_position" /* 岗位 */
                                    ) +
                                      _vm.$t("pc_biz_enroll_lbl_colon" /* ： */)
                                  )
                                ),
                              ]),
                              _vm.record.user.positionList
                                ? _c(
                                    "yxt-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.record.user.positionList,
                                        placement: "top",
                                        "open-filter": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mw-35 nowrap ellipsis",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.record.user.positionList)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("--")]),
                              _c("yxt-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_enroll_lbl_dept" /* 部门 */
                                    ) +
                                      _vm.$t("pc_biz_enroll_lbl_colon" /* ： */)
                                  )
                                ),
                              ]),
                              _vm.record.user.deptName
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "enroll-audit-info__department",
                                    },
                                    [
                                      _c(
                                        "yxt-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                            "open-filter": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  name: _vm.record.user
                                                    .deptName,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mw-35 nowrap ellipsis",
                                            },
                                            [
                                              _c("yxtbiz-dept-name", {
                                                attrs: {
                                                  name: _vm.record.user
                                                    .deptName,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("span", [_vm._v("--")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "bg-white p24 text-26 font-size-14 mt12" },
                  [
                    _c(
                      "div",
                      { staticClass: "yxtbiz-enroll-detail__project pb16" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-center font-size-16 font-bolder lh24",
                          },
                          [
                            _c("span", {
                              staticClass:
                                "yxtbiz-enroll-detail__title-identify",
                            }),
                            _c("span", { staticClass: "ml12" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_enroll_lbl_project" /* 报名项目 */
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "yxt-row",
                          { staticClass: "mt24" },
                          [
                            _c(
                              "yxt-col",
                              {
                                staticClass: "d-flex align-center ph16 mb16",
                                attrs: { span: 24 },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex-shrink-0 text-8c" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_enroll_lbl_projectname" /* 项目名称 */
                                        ) +
                                          _vm.$t(
                                            "pc_biz_enroll_lbl_colon" /* ： */
                                          )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "yxt-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.record.projectName,
                                      placement: "top",
                                      "open-filter": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-1 nowrap ellipsis" },
                                      [_vm._v(_vm._s(_vm.record.projectName))]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-enroll-detail__opinion pb16" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-center font-size-16 font-bolder lh24",
                          },
                          [
                            _c("span", {
                              staticClass:
                                "yxtbiz-enroll-detail__title-identify",
                            }),
                            _c("span", { staticClass: "ml12" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_enroll_lbl_auditopinion" /* 审核意见 */
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm.record.checkStatus === 0
                          ? [
                              _c(
                                "yxt-radio-group",
                                {
                                  staticClass: "mt20",
                                  model: {
                                    value: _vm.auditResult,
                                    callback: function ($$v) {
                                      _vm.auditResult = $$v
                                    },
                                    expression: "auditResult",
                                  },
                                },
                                [
                                  _c("yxt-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_enroll_lbl_formalstudent" /*正式学员*/
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("yxt-radio", { attrs: { label: 2 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_enroll_lbl_auditrefuse" /*审核不通过*/
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c("yxt-input", {
                                staticClass: "mt16",
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  maxlength: "200",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.checkOpinion,
                                  callback: function ($$v) {
                                    _vm.checkOpinion = $$v
                                  },
                                  expression: "checkOpinion",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "pt32" },
                                [
                                  _c(
                                    "yxt-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        loading: _vm.checkLoading,
                                      },
                                      on: { click: _vm.manageAudit },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "pc_biz_enroll_confirm_btn" /*确定*/
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c(
                                "yxt-row",
                                { staticClass: "mt24" },
                                [
                                  _c(
                                    "yxt-col",
                                    {
                                      staticClass:
                                        "d-flex align-center ph16 mb16",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-shrink-0 text-8c",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pc_biz_enroll_lbl_auditstatus" /* 审核状态 */
                                              ) +
                                                _vm.$t(
                                                  "pc_biz_enroll_lbl_colon" /* ： */
                                                )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm.record.checkStatus === 1
                                        ? _c("div", { staticClass: "flex-1" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_enroll_tip_auditsuccess" /* 审核成功 */
                                                )
                                              ) +
                                                " (" +
                                                _vm._s(
                                                  _vm.record.userType === 2
                                                    ? _vm.$t(
                                                        "pc_biz_enroll_lbl_formalstudent" /* 正式学员 */
                                                      )
                                                    : _vm.$t(
                                                        "pc_biz_enroll_lbl_substitutestudent" /* 替补学员 */
                                                      )
                                                ) +
                                                ")"
                                            ),
                                          ])
                                        : _c("div", { staticClass: "flex-1" }, [
                                            _vm._v(_vm._s(_vm.statusText)),
                                          ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.record.checkUserName
                                ? _c(
                                    "yxt-row",
                                    [
                                      _c(
                                        "yxt-col",
                                        {
                                          staticClass:
                                            "d-flex align-center ph16 mb16",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-shrink-0 text-8c",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_biz_enroll_lbl_auditor" /* 审核人 */
                                                  ) +
                                                    _vm.$t(
                                                      "pc_biz_enroll_lbl_colon" /* ： */
                                                    )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "flex-1" },
                                            [
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  name: _vm.record
                                                    .checkUserName,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.record.checkTime
                                ? _c(
                                    "yxt-row",
                                    [
                                      _c(
                                        "yxt-col",
                                        {
                                          staticClass:
                                            "d-flex align-center ph16 mb16",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-shrink-0 text-8c",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_biz_enroll_lbl_audittime" /* 审核时间 */
                                                  ) +
                                                    _vm.$t(
                                                      "pc_biz_enroll_lbl_colon" /* ： */
                                                    )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("div", { staticClass: "flex-1" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  _vm.record.checkTime,
                                                  "yyyy-MM-dd hh:mm"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.record.checkOpinion
                                ? _c(
                                    "yxt-row",
                                    [
                                      _c(
                                        "yxt-col",
                                        {
                                          staticClass:
                                            "d-flex align-center ph16 mb16",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-shrink-0 text-8c",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_biz_enroll_lbl_auditopinion" /* 审核意见 */
                                                  ) +
                                                    _vm.$t(
                                                      "pc_biz_enroll_lbl_colon" /* ： */
                                                    )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("div", { staticClass: "flex-1" }, [
                                            _vm._v(
                                              _vm._s(_vm.record.checkOpinion)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._t("next"),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }